// extracted by mini-css-extract-plugin
module.exports = {"root":"banner-content_root__u4L5b"};